import React, { useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";
import { AddFolderButton, ConfirmationDialog, CustomTooltip, SmallScreenModel } from "components";
import { TrashIcon } from "assets";
import { CheyCheyImageProps } from "../store/actionType";
import { deleteCheyCheyImage } from "../store/action";

interface ImageProps {
    imageData: CheyCheyImageProps;
    onClick: () => void;
}
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = DispatchProps & ImageProps;

const HandleDeleteImage: React.FC<Props> = ({ onDeleteImage, imageData, onClick }) => {
    const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
    const [deleteError, setDeleteError] = useState(null);

    const cheyCheyImageState = useSelector(
        (state: any) => state.cheyCheyImageReducer.cheyCheyImageState,
    );
    const handleDeleteGroup = (e: any) => {
        e.stopPropagation();
        onDeleteImage(imageData.id);
    };
    const toggleDeleteDialog = () => {
        setIsDeleteDialogOpen(!isDeleteDialogOpen);
    };
    useEffect(() => {
        setDeleteError(cheyCheyImageState.delete);
        if (cheyCheyImageState.delete === null) {
            setIsDeleteDialogOpen(false);
        }
    }, [cheyCheyImageState.delete]);
    console.log(imageData,"dsfghjhgjgh")
    return (
        <>
                <div className="relative flex flex-row justify-center items-center" >
                    <img
                        className=" object-cover"
                        src={`${imageData?.image}`}
                        alt="cheychey" />
                    <CustomTooltip title={"delete"} placement="bottom">
                        <span onClick={() => setIsDeleteDialogOpen(true)} className="absolute bg-white/50 top-0 right-0 p-1 m-1 hover:bg-primary-100 rounded-full">
                            <TrashIcon
                                className="size-5 text-red-500"
                            />
                        </span>
                    </CustomTooltip>

                </div>
                <SmallScreenModel
                    showModal={isDeleteDialogOpen}
                    setShowModal={setIsDeleteDialogOpen}
                >
                    <ConfirmationDialog
                        title={"Delete Group"}
                        message={"Are you sure you want to delete?"}
                        onConfirm={handleDeleteGroup}
                        onCancel={toggleDeleteDialog}
                        error={deleteError}
                    />
                </SmallScreenModel>
        </>
    );
};



const mapDispatchToProps = (dispatch: any) => ({
    onDeleteImage: (chey_chey_id: string) => dispatch(deleteCheyCheyImage(chey_chey_id)),
});
export default connect(null, mapDispatchToProps)(HandleDeleteImage);

